if (!customElements.get('vslf-size-panel')) {
  customElements.define('vslf-size-panel', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.source = this.querySelector('template');
      this.body = this.querySelector('[data-size-content]');
      this.heading = this.querySelector('.vslf-size-panel__header h2');
      this.section = this.closest('.shopify-section');
      if (!this.dialog || !this.source || !this.section || !this.dialog.showModal) return;
      this.onClick = this.handleClick.bind(this);
      this.onClose = () => {
        document.body.style.overflow = this.previousOverflow || '';
        const target = this.opener?.isConnected ? this.opener : this.section.querySelector('.vslf-size-guide-link');
        target?.focus({ preventScroll: true });
      };
      this.section.addEventListener('click', this.onClick, true);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onBackdrop = event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
    }
    disconnectedCallback() {
      this.section?.removeEventListener('click', this.onClick, true);
      if (this.dialog?.open) {
        document.body.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('click', this.onBackdrop);
    }
    handleClick(event) {
      if (event.target.closest('[data-size-close]')) {
        this.dialog.close();
        return;
      }
      const link = event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const inside = this.dialog.contains(link);
      if (!inside && !link.matches('.vslf-size-guide-link, .product__accordion a[href*="/pages/size-guide"]')) return;
      const url = new URL(link.href, location.href);
      const raw = link.getAttribute('href');
      if (!url.hash || (inside && !raw.startsWith('#'))) return;
      const id = decodeURIComponent(url.hash.slice(1));
      const original = this.source.content.querySelector('#' + CSS.escape(id));
      if (!original) return;
      event.preventDefault();
      event.stopPropagation();
      const card = original.cloneNode(true);
      const heading = card.querySelector('h2');
      if (heading) {
        this.heading.textContent = heading.textContent;
        heading.remove();
      }
      card.removeAttribute('id');
      card.removeAttribute('style');
      card.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      card.querySelectorAll('script, style').forEach(el => el.remove());
      card.querySelectorAll('.vslf-table-wrap').forEach(el => {
        el.tabIndex = 0;
        el.setAttribute('role', 'region');
        el.setAttribute('aria-label', this.heading.textContent);
      });
      this.body.replaceChildren(card);
      if (!this.dialog.open) {
        this.opener = link;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      this.body.scrollTop = 0;
      this.querySelector('[data-size-close]').focus({ preventScroll: true });
    }
  });
}
